<template>
    <div>
        <Modal
            v-for="(item, key) in noticeList"
            v-model="item.modal"
            :key="key"
            :title="item.title"
            :width="dialogWidth"
            class="noticeDialog"
        >
        <div v-html="item.content"></div>
        <ul>
            <li style="cursor:pointer;margin-bottom:10px;color:blue;" v-for="(item2, key) in item.fileList" :key="key" @click="fileDowmload(item2.docId)">{{item2.fileName}}</li>
        </ul>
        </Modal>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data () {
        return {
            modal: false,
            noticeObj: {
                title: '',
                content: ''
            },
            fileList: [],
            noticeList: [],
            dialogWidth: 400,
            INT_DIALOG: [],
        };
    },
    methods: {
        getNotice () {
            axios.post('/gscint/advertise/selectList', {
                pageNum: 1,
                pageSize: 10,
                status: '0',
                title: '',
                type: '海外弹窗公告'
            })
            .then((res) => {
                let noticeDialogIds = JSON.parse(localStorage.getItem('noticeDialogIds')) || [];
                let ids = [];
                this.noticeList = [];
                if (res.data.data.list.length > 0) {
                    let list = res.data.data.list;
                    list.map((item) => {
                        let fileList = [];
                        if (item.appendixName) {
                            item.appendixName.split(',').map((item2, index) => {
                                fileList.push({
                                    fileName: item2,
                                    docId: item.appendix.split(',')[index]
                                });
                            });
                        }
                        this.noticeList.push({
                            ...item,
                            fileList,
                            modal: !noticeDialogIds.includes(item.id)
                        });
                    });
                    this.noticeList.map((item) => {
                        ids.push(item.id);
                    });
                    localStorage.setItem('noticeDialogIds', JSON.stringify(ids));
                }
            });
        },
        fileDowmload (docId) {
            window.open(`/gscint/supplierfile/downloadFile?docId=${docId}`);
        }
    },
    mounted () {
        this.getNotice();
        this.getDictByCode('INT_DIALOG', (data) => {
            if (data.length > 0) {
                this.dialogWidth = data[0].value || 400;
            }
        });
    }
};
</script>
<style scoped>
/deep/ .noticeDialog .m-modal-header {
    border-bottom: 1px solid #e9eaec;
}
</style>